import {
  FETCH_HU_LOCAL_RESULTS,
  FETCH_HU_LOCAL_RESULTS_SUCCESS,
  FETCH_HU_LOCAL_RESULTS_FAILURE,
  FETCH_HU_LOCAL_RESULTS_FORBIDDEN,
  FETCH_HU_LOCAL_APP_RESULTS,
  FETCH_HU_LOCAL_APP_RESULT_SUCCESS,
  FETCH_HU_LOCAL_APP_RESULTS_COMPLETE,
} from './actionTypes';

export const initialState = {
  results: [],
  services: [],
  communities: [],
  resources: [],
  apps: [],
  isLoading: false,
  areAppsLoading: false,
  errorMessage: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_HU_LOCAL_RESULTS:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case FETCH_HU_LOCAL_RESULTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        results: action.results,
        services: action.services,
        communities: action.communities,
        resources: action.resources,
      };
    case FETCH_HU_LOCAL_RESULTS_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_HU_LOCAL_RESULTS_FORBIDDEN:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.errorMessage,
      };
    case FETCH_HU_LOCAL_APP_RESULTS:
      return {
        ...state,
        apps: [],
        areAppsLoading: true,
      };
    case FETCH_HU_LOCAL_APP_RESULT_SUCCESS:
      return {
        ...state,
        apps: [...state.apps, action.app],
      };
    case FETCH_HU_LOCAL_APP_RESULTS_COMPLETE:
      return {
        ...state,
        areAppsLoading: false,
      };
  }
  return state;
}
